<body>
<div class="card">
  <div class="card-header">
    <div class="card-title">{{fonte}}</div>
    <div class="currency-symbol">$</div>
  </div>
  <div class="card-value">R$ {{valor}}</div>
  <div class="change-indicator">
    <div class="change-value">{{porcentagem}}%</div>
  </div>
  <div class="change-description">em relação ao mês anterior</div>
</div>
</body>
